import React from "react";
import Accordian from "../../Components/Accordian";
import { opentoaddData, lmsData } from "../../../../models/lms_data_api";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../../app/store";
import { useLocation } from "react-router-dom";
import Loader from "../../../../Global_Component/loader/loader";
import { handlePaginationData } from "../../../../lms_utility_func";
import PaginationControlled from "../../Components/pagination/pagination";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import { useState } from "react";

type lmsAllprops = {
  opentoAdd: opentoaddData;
  setOpentoAdd: Function;
};
function LmsAll({ opentoAdd, setOpentoAdd }: lmsAllprops) {
  const dispatch = useDispatch();
  const location = useLocation();
  const [page, setPage] = useState(1);
  const [row, setrow] = useState(10);
  const {
    lmsData: { all },
    appData: { dataAccToPage, message, loader, filterSearch },
  } = useSelector((state: RootState) => state.lms);
  React.useEffect(() => {
    if (!filterSearch) {
      if (all !== null) {
        handlePaginationData(all, page, row, "No records", true, dispatch);
      }
    } else {
      handlePaginationData(
        filterSearch,
        page,
        row,
        "No Match Found",
        false,
        dispatch
      );
    }
  }, [all, page, row]);

  // React.useEffect(() => {
  //   let user = searchParams.get("user");
  //   let Lead = searchParams.get("LeadId");
  //   if (user && all?.length > 0) {
  //     setvariable_data([...filter_data_acc_user(all_leads, Number(user))]);
  //   } else if (Lead && location.pathname === "/lms") {
  //     setvariable_data([
  //       ...all_leads.filter((item) => item.LeadId === Number(Lead)),
  //     ]);
  //   }
  // }, [searchParams, all_leads]);
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };
  if (loader) {
    return (
      <div className="w-full h-[35rem] flex-auto flex justify-center items-center ">
        <Loader />
      </div>
    );
  } else {
    return (
      <div className="flex flex-col gap-4 h-full w-full ">
        <div className="flex flex-col gap-5 ">
          {dataAccToPage?.length ? (
            dataAccToPage.map((item) => (
              <Accordian
                opentoAdd={opentoAdd}
                setOpentoAdd={setOpentoAdd}
                item={item}
                key={item.LeadId}
              />
            ))
          ) : (
            <div className="flex justify-center items-center h-full w-full gap-2">
              <h1 className="text-2xl text-red-900 tracking-widest">
                {message}
              </h1>
              <span className="text-4xl">😭</span>
            </div>
          )}
        </div>
        <div className="flex self-start w-full justify-between items-center gap-8  py-6">
          <div className="flex">
            <FormControl sx={{ m: 1, minWidth: 80 }}>
              <InputLabel
                id="demo-simple-select-autowidth-label"
                color="success"
              >
                row
              </InputLabel>
              <Select
                labelId="demo-simple-select-autowidth-label"
                id="demo-simple-select-autowidth"
                value={row}
                onChange={(e) => setrow(Number(e.target.value))}
                autoWidth
                color="success"
                label="row"
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={40}>40</MenuItem>
                <MenuItem value={80}>80</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div>
            <PaginationControlled
              handleChange={handleChange}
              page={page}
              row={row}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default React.memo(LmsAll);
